// import { Suspense } from 'react';
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { publicRoutes, protectedRoutes } from './routes.config';
// import ProtectedRoute from './ProtectedRoute';
// import PublicRoute from './PublicRoute';
// import Loader from '../components/common/Loader/Loader';

// const AppRoutes = () => {
//     return (
//         <Suspense
//             fallback={
//                 <div style={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     height: '100vh'
//                 }}>
//                     <Loader size="large" />
//                 </div>
//             }
//         >
//             <Routes>
//                 {/* Public Routes */}
//                 {publicRoutes.map((route) => (
//                     <Route
//                         key={route.path}
//                         path={route.path}
//                         element={
//                             <PublicRoute>
//                                 <route.component />
//                             </PublicRoute>
//                         }
//                     />
//                 ))}

//                 {/* Protected Routes */}
//                 {protectedRoutes.map((route) => (
//                     <Route
//                         key={route.path}
//                         path={route.path}
//                         element={
//                             <ProtectedRoute roles={route.roles}>
//                                 <route.component />
//                             </ProtectedRoute>
//                         }
//                     />
//                 ))}

//                 {/* 404 / Default */}
//                 <Route path="*" element={<Navigate to="/login" replace />} />
//             </Routes>
//         </Suspense>
//     );
// };

// export default AppRoutes;

import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, protectedRoutes } from './routes.config';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import Loader from '../components/common/Loader/Loader';

const loaderWrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <div style={loaderWrapperStyle}>
          <Loader size="large" />
        </div>
      }
    >
      <Routes>
        {publicRoutes.map((route) => {
          const Component = route.component;

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <PublicRoute>
                  <Component />
                </PublicRoute>
              }
            />
          );
        })}

        {protectedRoutes.map((route) => {
          const Component = route.component;

          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                <ProtectedRoute module={route.module} action={route.action}>
                  <Component />
                </ProtectedRoute>
              }
            />
          );
        })}

        <Route path="/unauthorized" element={<div>Unauthorized</div>} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;